import {Resolvable} from 'ln/components/Resolve';
import Model from 'ln/model/Model';


export class Text extends Model implements Resolvable {

    public constructor(json: object) {
        super({
            level: null,
            text: '',
            ...json
        });
    }

    public readonly text: string;

    public get level(): number|null {
        return Number(this.get('level') || 0) || null;
    }

    public getViewName(): string {
        return 'Text';
    }
}
